<template>
  <div class="home-flexible-investment">
    <div class="section-title">{{ $t('fundingOptions') }}</div>
    <div class="card banner" v-if="currentProduct && Object.keys(currentProduct).length">
      <div class="banner-flexible">
        <img src="@/assets/image/home/flexible-investment/icon-plane.svg" class="icon-plane">
        <div class="name">{{ this.$t('flexibleInvestment') }}</div>
        <div class="duration">{{ this.$t('duration') }}</div>
        <div class="rate-tip">
          {{ `${this.$t('returnRate')} ` }}
          <span class="rate">{{ currentProduct.interestPercent }}%</span>
          p.a.
        </div>
      </div>
      <div class="banner-form">
        <div class="amount">
          <div class="label">{{ $t('amountLabel') }}</div>
          <md-field>
            <md-input-item
              name="amount"
              type="money"
              v-model="form.amount"
              class="input-money-container bordered"
              @change="delayExcute(1000, getRevenue)"
            >
              <cleave
                slot="left"
                v-model="form.amount"
                :placeholder="$t('amountPlaceholder')"
                :options="amountFormatOptions"
                class="input-money-inner"
              ></cleave>
            </md-input-item>
          </md-field>
        </div>
        <div class="interest">
          <div class="label">{{ $t('interestLabel') }}</div>
          <div class="interest-value">
            {{ dailyRevenue | formatMoney }}
          </div>
        </div>
        <div class="start-funding">
          <md-button type="primary" round @click="goFunding">{{ $t('startFunding') }}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, InputItem, Field } from 'mand-mobile'
import Cleave from 'vue-cleave-component'
import { amountOptions } from '@/lib/cleave'
import productMixin from '@/mixins/product'

export default {
  i18n: {
    messages: {
      en: {
        fundingOptions: 'Funding Options',
        duration: 'WITHDRAW ANYTIME',
        flexibleInvestment: '- FLEXIBLE INVESTMENT -',
        returnRate: 'Return Projections',
        amountLabel: 'Your total lending commitment',
        amountPlaceholder: 'Please input Rupiah',
        interestLabel: 'Interests Per Day',
        startFunding: 'Start Funding',
      },
      id: {
        fundingOptions: 'Pilihan Pendanaan',
        duration: 'TARIK KAPANPUN',
        flexibleInvestment: '- PENDANAAN FLEKSIBEL -',
        returnRate: 'Proyeksi Keuntungan',
        amountLabel: 'Jumlah pendanaan Anda',
        amountPlaceholder: 'Masukan jumlah rupiah',
        interestLabel: 'Keuntungan Per Hari',
        startFunding: 'Mulai pendanaan',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    Cleave,
  },
  mixins: [productMixin],
  data() {
    return {
      amountFormatOptions: amountOptions,
    }
  },
  computed: {
    currentProduct() {
      return this.$store.state.flexibleProducts[0]
    },
  },
  methods: {
    goFunding() {
      this.$router.push({
        name: 'FlexibleProduct',
        query: {
          investedId: this.currentProduct.id,
          amount: this.form.amount,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.home-flexible-investment {
  display: flex;
  flex-direction: column;
  padding: 30px 20px 0;
}

.banner-flexible {
  position: relative;
  height: 316px;
  background-image: url('../../assets/image/home/flexible-investment/banner-flexible.png');
  background-size: cover;
  border-radius: 6px 6px 0 0;
  padding: 45px 10px;
  text-align: center;
  .icon-plane {
    position: absolute;
    top: 76px;
    right: 56px;
    height: 40px;
  }
  .name {
    padding: 8px 4px;
    border: 2px solid #000;
    font-size: 20px;
  }
  .duration {
    padding: 40px 0 14px 0;
    font-size: 46px;
    font-weight: bold;
  }
  .rate-tip {
    font-style: italic;
    font-size: 18px;
    .rate {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.banner-form {
  padding: 16px 12px;
  .label {
    font-size: 12px;
    color: #555;
    margin-bottom: 10px;
  }
  .interest {
    margin-top: 16px;
    .interest-value {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.2em;
    }
  }
  .start-funding /deep/ {
    margin-top: 30px;
  }
}
</style>
